import { IdTokenParsed } from "../types";

export default function getUserDisplayName(idTokenParsed?: IdTokenParsed) {
  return [idTokenParsed?.given_name, idTokenParsed?.family_name]
    .filter(Boolean)
    .join(" ");
}
